import { useContext } from 'react';
import { apiContext } from '../apiContext';

export const useGetApiClient = () => {
  const { api } = useContext(apiContext);

  return api;
};
